/** Copy Media Lab — Andreina Roa × TNO Media Lab */
export const andreinaRoaMediaLabWho = {
  title: 'TNO Media Lab: producción en casa para Andreina Roa',
  subtitle:
    'Programa en estudio, clips para redes y clips promocionales en YouTube — todo con audiencia dirigida a TNO Network.',
  description:
    'TNO Media Lab es el centro de producción de TNO Network. Para Andreina Roa asumimos la producción del programa en nuestros estudios, clips para redes y piezas promocionales en YouTube que empujan tráfico hacia la plataforma TNO Network.',
};

export const andreinaRoaMediaLabWhy = {
  title: '¿Por qué producir con TNO Media Lab?',
  description:
    'Un solo partner en TNO: programa in-house, paquete de clips ($50 adicional), publicación en TNO Network, bonificación en Digest y modelo claro de comercialización — 30% a la radio si trae el cliente Andreina Roa; 50/50 si lo trae TNO.',
  ctaText: 'Agendar reunión',
};

export const andreinaRoaMediaLabBenefits = {
  overline: 'Producción TNO',
  title: 'Tres bloques, un plan mensual',
  subtitle:
    'Programa en estudio, alcance social (clips) y promoción en YouTube — destino TNO Network.',
  items: [
    {
      title: 'Programa en estudio (Bloque 1)',
      subtitle:
        'Producción del espacio principal en TNO Media Lab: grabación, edición y entrega lista para publicar en TNO Network.',
      colorKey: 'blue',
    },
    {
      title: 'Clips para redes (Bloque 2)',
      subtitle:
        '12 clips por episodio para Instagram, LinkedIn, TikTok y X — incluidos en el paquete adicional de $50 USD/mes.',
      colorKey: 'amber',
    },
    {
      title: 'YouTube promocional (Bloque 3)',
      subtitle:
        '4 clips promocionales por episodio (Shorts y avances) que impulsan al programa en TNO Network — mismo paquete de $50 USD/mes.',
      colorKey: 'pink',
    },
    {
      title: 'Bonificación TNO Digest',
      subtitle:
        '4 artículos mensuales en tnonetwork.com con SEO y enlaces al programa.',
      colorKey: 'teal',
    },
  ],
};

export const andreinaRoaMediaLabValues = {
  overline: 'Valores del Lab',
  title: 'ADN de la producción',
  hideAdnHeading: true,
  subtitle:
    'Tecnología broadcast, claridad editorial y un flujo mensual predecible desde el Media Lab de TNO.',
  items: [
    {
      title: 'Producción in-house',
      subtitle: 'Todo se produce en TNO Media Lab con estándar de la red.',
    },
    {
      title: 'Alcance + conversión',
      subtitle:
        'Redes y clips promocionales de YouTube empujan audiencia a TNO Network.',
    },
    {
      title: 'Comercialización',
      subtitle:
        'Opcional: cliente de Andreina Roa → 30% para TNO; cliente de la radio → 50% Andreina y 50% TNO.',
    },
    {
      title: 'Inversión clara',
      subtitle:
        '$150 USD mensuales: programa $100 y paquete clips $50 adicional (12 redes + 4 promocionales YouTube por episodio).',
    },
  ],
};

export const andreinaRoaMediaLabAreYouReady = {
  headline: 'Activemos la producción para Andreina Roa',
  subheadline: '¿Listos para el primer ciclo mensual?',
  body:
    'Coordinemos calendario de grabación, clips para redes y clips promocionales en YouTube con destino TNO Network.',
  ctaPrimary: 'Quiero esta propuesta',
  ctaSecondary: 'TNO Media Lab',
  ctaSecondaryHref: '/medialab',
  whatsappNumber: '04123964576',
  footerText:
    '© TNO Network 2026 | Andreina Roa × TNO Media Lab | The Content Evolution.',
};
